(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const isHomepage = window.location.pathname === '/' || window.location.pathname === '/index';
  const megaMenus = document.querySelectorAll('.mega-menu');
  const megaSubMenus = document.querySelectorAll('.mega-menu-sub');
  const mainContent = document.getElementById('MainContent');
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      // Coalesce scroll work into one run per animation frame, and register the
      // listener as passive so scrolling is never blocked on it.
      this.scrollTicking = false;
      this.onScrollHandler = () => {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        requestAnimationFrame(() => {
          this.scrollTicking = false;
          this.onScroll();
        });
      };
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.addMegaMenuListeners(); // Add listeners for mega menu open/close
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    addMegaMenuListeners() {
      const megaSubMenus = document.querySelectorAll('.mega-menu-sub');

      megaMenus.forEach((megaMenu) => {
        const subMenu = megaMenu.querySelector('.menu-sub-list');
        const subMenuContent = megaMenu.querySelector('.mega-menu__content');
        megaMenu.addEventListener('toggle', () => {
          if (subMenu) {
            subMenu.classList.remove('show');
          }
          if (subMenuContent) {
            subMenuContent.classList.remove('subShow');
          }
          if (megaMenu.open) {
            setTimeout(() => {
              if (subMenu) {
                subMenu.classList.add('show');
              }
              if (subMenuContent) {
                subMenuContent.classList.add('subShow');
              }
            }, 100);
          }
          this.updateHeaderClasses();
        });
      });

      // Handle sub-menu accordion behavior
      megaSubMenus.forEach((megaSubMenu) => {
        megaSubMenu.addEventListener('toggle', () => {
          // Only close siblings when this menu is opening (not closing)
          if (megaSubMenu.hasAttribute('open')) {
            const parentMenu = megaSubMenu.closest('.menu-sub-list');
            if (parentMenu) {
              const siblingSubMenus = parentMenu.querySelectorAll('.mega-menu-sub');
              siblingSubMenus.forEach((sibling) => {
                if (sibling !== megaSubMenu && sibling.hasAttribute('open')) {
                  sibling.removeAttribute('open');
                }
              });
            }
          }
        });
      });
    }

    updateHeaderClasses() {
      const headerDiv = this.header;
      let isMegaMenuOpen = false;

      megaMenus.forEach((megaMenu) => {
        if (megaMenu.hasAttribute('open')) {
          isMegaMenuOpen = true;
        }
      });

      if (isMegaMenuOpen && window.scrollY !== 0) {
        headerDiv.classList.add('scrolled-past-header', 'headerDiv');
        headerDiv.classList.remove('headerFullExpanded');
        document.body.classList.add('no-scroll');
      } else if (isMegaMenuOpen && window.scrollY === 0) {
        headerDiv.classList.add('headerFullExpanded');
        document.body.classList.add('no-scroll');
        headerDiv.classList.remove('scrolled-past-header', 'headerDiv');
      } else if (!isHomepage && this.currentScrollTop > this.headerBounds.bottom) {
        headerDiv.classList.add('scrolled-past-header', 'headerDiv', 'headerFullExpanded');
        document.body.classList.remove('no-scroll');
      } else if (!isHomepage && this.currentScrollTop <= this.headerBounds.bottom) {
        headerDiv.classList.remove('scrolled-past-header', 'headerDiv', 'headerFullExpanded');
      } else {
        headerDiv.classList.remove('headerFullExpanded');
        document.body.classList.remove('no-scroll');
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
      this.updateHeaderClasses(); // Update classes on scroll too
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function () {
    const headerWrapper = document.querySelector('.header-wrapper');

    headerWrapper.addEventListener('focusin', function () {
      headerWrapper.classList.add('menu-open-active');
    });
    headerWrapper.addEventListener('focusout', function () {
      headerWrapper.classList.remove('menu-open-active');
    });
  });

  const headerDiv = document.querySelector('.section-header');

  if (!isHomepage) {
    headerDiv.classList.add('scrolled-past-header');
    headerDiv.classList.add('headerDiv');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-with-switch"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swatches = document.querySelectorAll('.banner-swatch__item');
    const mainImage = document.querySelector('.image-banner-main');
    const overlayImage = document.querySelector('.overlay-image');
    const mainButton = document.querySelector('.banner-swatch__buttons');
    const mainHref = document.querySelector('.button-swatch__toggle');

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', function (event) {
        event.preventDefault();

        const parentImageURL = this.getAttribute('data-parent-image');
        const buttonURL = this.querySelector('.banner-swatch__button-url').textContent.trim(); // Add .trim()
        const buttonLabel = this.querySelector('.banner-swatch__button-label').textContent.trim(); // Add .trim()

        swatches.forEach((s) => s.classList.remove('is_active'));
        this.classList.add('is_active');

        if (parentImageURL && mainImage.srcset !== parentImageURL) {
          // Changed mainImage !== parentImageURL to mainImage.srcset !== parentImageURL
          overlayImage.srcset = parentImageURL;

          if (mainHref) {
            mainHref.setAttribute('href', buttonURL);
          }

          if (mainButton) {
            mainButton.textContent = buttonLabel;
          }

          swatch.classList.add('is_active');
          overlayImage.onload = () => {
            overlayImage.style.opacity = 1;
            setTimeout(() => {
              mainImage.srcset = parentImageURL;
              overlayImage.style.opacity = 0;
            }, 500);
          };
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
